import { z } from 'zod';
import { createToolSignature, ToolSignature } from './tool-signature';

export const getInsideNetworkRecommendationsToolSignature = createToolSignature({
    name: 'getInsideNetworkRecommendationsTool',
    description:
        'Get recommendations of people to contact inside the users LinkedIn Network. These recommendations are based on the users LinkedIn Network and the users LinkedIn Profile and are suggestions of new people to reach out to. The tool can also directly display the recommendations to the user in a list UI with the display parameter.',
    inputSchema: z.object({}),
    outputSchema: z.array(
        z.object({
            linkedinProfileUrl: z.string().describe('The LinkedIn profile URL of the person'),
            name: z.string().describe('The name of the person'),
            motivation: z.string().describe('The motivation for the recommendation').nullable(),
            accountId: z.string().describe('The accountId of the company the person works at').nullable(),
            location: z.string().describe('The location of the person').nullable(),
        }),
    ),
    toolCallUi: (input) => `Getting inside network recommendations`,
});
